import FinderScreen from "./FinderScreen";

export const FINDER_SCREEN = "finder";

export default {
    [FINDER_SCREEN]: FinderScreen,
};
